namespace GeniuzPOS.QRreport {
    export interface QRywcSpec1302Form {
        Id: Serenity.StringEditor;
        ReportId: Serenity.LookupEditor;
        ReportName: Serenity.StringEditor;
        UrlReport: Serenity.StringEditor;
        DataStructureName: Serenity.StringEditor;
        LineNo: Serenity.IntegerEditor;
        DateBegin: Serenity.DateEditor;
        DateEnd: Serenity.DateEditor;
        ShopId: Serenity.LookupEditor;
        PosId: Serenity.LookupEditor;
    }

    export class QRywcSpec1302Form extends Serenity.PrefixedContext {
        static formKey = 'QRreport.QRywcSpec1302';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!QRywcSpec1302Form.init)  {
                QRywcSpec1302Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;

                Q.initFormType(QRywcSpec1302Form, [
                    'Id', w0,
                    'ReportId', w1,
                    'ReportName', w0,
                    'UrlReport', w0,
                    'DataStructureName', w0,
                    'LineNo', w2,
                    'DateBegin', w3,
                    'DateEnd', w3,
                    'ShopId', w1,
                    'PosId', w1
                ]);
            }
        }
    }
}
